import { Button } from '@abyss/web/ui/Button';
import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { Text } from '@abyss/web/ui/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { getFeatureFlag } from '../../../../common/Utils';
import { useLagoon } from '../../../../hooks/useLagoon';

interface ToggleExpandProps {
  isExpanded: boolean;
  handleToggleExpand: () => void;
  programTitle: string;
  length?: number;
}

const ToggleExpand: React.FC<ToggleExpandProps> = ({
  isExpanded,
  handleToggleExpand,
  programTitle,
  length,
}) => {
  const { t } = useTranslation();

  const featureFlags = useLagoon('feature-flags')();
  const enableFacilityDetailsAnalytics = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_FACILITY_DETAILS_ANALYTICS
  );

  const handleClick = () => {
    handleToggleExpand();
    if (enableFacilityDetailsAnalytics) {
      adobeLinkTrackEvent({
        name: isExpanded ? 'show less' : 'show more',
        location: programTitle,
      });
    }
  };

  const renderToggleContent = () => {
    const textKey = isExpanded
      ? 'CONTENT_FILTERS.TOGGLE_EXPAND_SHOW_LESS'
      : 'CONTENT_FILTERS.TOGGLE_EXPAND_SHOW_MORE';
    const icon = isExpanded ? 'expand_less' : 'expand_more';

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <Text color="$interactive1" size="$sm">
          {t(textKey)}
          {isExpanded ? ' (3)' : ` (${length})`}
        </Text>
        <IconMaterial icon={icon} />
      </div>
    );
  };

  return (
    <Button
      data-testid="toggle-expand"
      onClick={handleClick}
      style={{
        cursor: 'pointer',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '18px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '0px',
        height: 'auto',
      }}
      variant="tertiary"
    >
      {renderToggleContent()}
    </Button>
  );
};

export default ToggleExpand;
